import { useTranslation } from 'react-i18next';
import styles from './SuspendedLock.module.css';

/** A live pick bet365 has suspended for the moment (a big chance, a goal
 *  being checked): a lock in place of its price, until it reopens. */
export const SuspendedLock = () => {
  const { t } = useTranslation();
  return (
    <span className={styles.lock} role="img" aria-label={t('odd_suspended')}>
      <svg viewBox="0 0 24 24" aria-hidden>
        <path
          d="M7 10V7a5 5 0 0 1 10 0v3"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        <rect
          x="4.5"
          y="10"
          width="15"
          height="11"
          rx="2.5"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

/** True for a live pick that is suspended now. */
export const isSuspendedOdd = (odd: unknown): boolean =>
  !!(odd as { suspended?: boolean } | null)?.suspended;
